import { GET_ENCAISSEMENTS, GET_ENCAISSEMENTS_BY_USER, GET_ENCAISSEMENTS_FOR_COMMISSION, GET_REMAINING_ENCAISSEMENTS, GET_PTF_V_ENCAISSEMENTS, GET_PTF_ANPV_ENCAISSEMENTS, GET_PTF_DELAY_ENCAISSEMENTS, GET_PTF_BV_ENCAISSEMENTS, GET_PTF_S_ENCAISSEMENTS, GET_PTF_COMPTA_ENCAISSEMENTS, GET_PTF_C_ENCAISSEMENTS, GET_RAP_ENCAISSEMENTS, GET_EI_ENCAISSEMENTS, GET_ENCAISSEMENT_REPLACMENT, GET_SPECIFIC_ENCAISSEMENT, ADD_ENCAISSEMENT, EDIT_ENCAISSEMENT, ENCAISSEMENTS_STATUT_PTF_BV, DELETE_ENCAISSEMENT, ENCAISSEMENTS_LOADING, CLEAR_ENCAISSEMENTS, CLEAR_REMAINING_ENCAISSEMENTS } from '../types';
import { IAction, IEncaissement } from '../../types/interfaces';

const arr = ["ptfVEncaissements", "ptfAnpvEncaissements", "ptfDelayEncaissements", "ptfBvEncaissements", "ptfSEncaissements", "ptfComptaEncaissements", "ptfCEncaissements", "preEiEncaissements", "eiEncaissements", "repEncaissements"]
const initialState = {
  encaissements: [],
  remainingEncaissements: [],
  // ptfVEncaissements: [],
  // ptfAnpvEncaissements: [],
  // ptfDelayEncaissements: [],
  // ptfBvEncaissements: [],
  // ptfSEncaissements: [],
  // ptfComptaEncaissements: [],
  // ptfCEncaissements: [],
  // preEiEncaissements: [],
  // eiEncaissements: [],
  // repEncaissements: [],
  ...Object.fromEntries(
    arr.map(key => [
      key,
      []
    ])
  ),
  info: {},
  loading: false
};

// interface IState {
//   encaissements: IEncaissement[];
//   remainingEncaissements: IEncaissement[];
//   ptfVEncaissements: IEncaissement[];
//   ptfAnpvEncaissements: IEncaissement[];
//   ptfDelayEncaissements: IEncaissement[];
//   ptfBvEncaissements: IEncaissement[];
//   ptfSEncaissements: IEncaissement[];
//   ptfComptaEncaissements: IEncaissement[];
//   ptfCEncaissements: IEncaissement[];
//   preEiEncaissements: IEncaissement[];
//   eiEncaissements: IEncaissement[];
//   repEncaissements: IEncaissement[];
//   info: any;
// }

export default function(state: any/*: IState*/ = initialState, action: IAction) {
  switch (action.type) {
    case GET_ENCAISSEMENTS:
    case GET_ENCAISSEMENTS_BY_USER:
    case GET_ENCAISSEMENTS_FOR_COMMISSION:
      return {
        ...state,
        encaissements: action.payload,
        loading: false
      };
    case GET_REMAINING_ENCAISSEMENTS:
      return {
        ...state,
        remainingEncaissements: action.payload,
        loading: false
      };
    case GET_PTF_V_ENCAISSEMENTS:
      return {
        ...state,
        ptfVEncaissements: action.payload,
        loading: false
      };
    case GET_PTF_ANPV_ENCAISSEMENTS:
      return {
        ...state,
        ptfAnpvEncaissements: action.payload,
        loading: false
      };
    case GET_PTF_DELAY_ENCAISSEMENTS:
      return {
        ...state,
        ptfDelayEncaissements: action.payload,
        loading: false
      };
    case GET_PTF_BV_ENCAISSEMENTS:
      return {
        ...state,
        ptfBvEncaissements: action.payload,
        loading: false
      };
    case GET_PTF_S_ENCAISSEMENTS:
      return {
        ...state,
        ptfSEncaissements: action.payload,
        loading: false
      };
    case GET_PTF_COMPTA_ENCAISSEMENTS:
      return {
        ...state,
        ptfComptaEncaissements: action.payload,
        loading: false
      };
    case GET_PTF_C_ENCAISSEMENTS:
      return {
        ...state,
        ptfCEncaissements: action.payload,
        loading: false
      };
    case GET_RAP_ENCAISSEMENTS:
      return {
        ...state,
        preEiEncaissements: action.payload,
        loading: false
      };
    case GET_EI_ENCAISSEMENTS:
      return {
        ...state,
        eiEncaissements: action.payload,
        loading: false
      };
    case GET_ENCAISSEMENT_REPLACMENT:
      return {
        ...state,
        repEncaissements: action.payload,
        loading: false
      };
    case GET_SPECIFIC_ENCAISSEMENT:
      return {
        ...state,
        info: action.payload,
        loading: false
      };
    case ENCAISSEMENTS_LOADING:
      return {
        ...state,
        loading: true
      };
    case CLEAR_ENCAISSEMENTS:
      return {
        ...state,
        encaissements: [],
        ptfVEncaissements: [],
        ptfAnpvEncaissements: [],
        ptfDelayEncaissements: [],
        ptfBvEncaissements: [],
        ptfSEncaissements: [],
        ptfComptaEncaissements: [],
        ptfCEncaissements: [],
        preEiEncaissements: [],
        eiEncaissements: [],
        repEncaissements: [],
      };
    case CLEAR_REMAINING_ENCAISSEMENTS:
      return {
        ...state,
        remainingEncaissements: []
      };
    case ADD_ENCAISSEMENT:
      return {
        ...state,
        encaissements: [...state.encaissements, action.payload]
      };
    case EDIT_ENCAISSEMENT:
      return {
        ...state,
        encaissements: state.encaissements.map(e => e.id == action.payload.id ? action.payload : e),
        ...Object.fromEntries(
          arr.map(key => [
            key,
            state[key].map(e => e.id == action.payload.id ? action.payload : e)
          ])
        )
      };
    // case ENCAISSEMENTS_STATUT_PTF_BV:
    //   return {
    //     ...state,
    //     ptfBvEncaissements: action.payload && action.payload.length ? state.ptfBvEncaissements.filter(e => {
    //       for(let encaissement of action.payload)
    //         if(encaissement.id == e.id)
    //           return false
    //       return true
    //     }) : state.ptfBvEncaissements,
    //     info: action.payload && action.payload.length && action.payload.find(e => e.id === state.info.id) ? action.payload.find(e => e.id === state.info.id) : state.info
    //   };
    case DELETE_ENCAISSEMENT:
      return {
        ...state,
        encaissements: state.encaissements.filter(e => e.id !== action.payload)
      };
    default:
      return state;
  }
}
